// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7960":"2be30574","9424":"8e232550","9428":"c298e9dc"}[chunkId] + ".chunk.css";
};